
import { GET_MODALITY_TYPES, GET_MODALITY_TYPES_SUCCESS } from '../../constants/ActionTypes';
export const getAllModalityTypes = () => {
    return {
        type: GET_MODALITY_TYPES,
    };
}
export const getModalityTypesSuccess = (modalityTypes) => {
    return {
        type: GET_MODALITY_TYPES_SUCCESS,
        modalityTypes: modalityTypes
    }
}